import * as React from "react";
import * as SRD from "@projectstorm/react-diagrams";
import { UserIntentNodeModel } from "../../../../model/workflowEditor";
import {BaseWidget} from "../BaseWidget/BaseWidget";
import { useSelector } from "react-redux";
import { selectIntentById } from "../../../../business/selectors/intentSelectors";
import { RootState } from "../../../../model/rootReducer";

type UserIntentWidgetProps = {
  engine: SRD.DiagramEngine;
  node: UserIntentNodeModel;
};

const UserIntentWidget: React.FunctionComponent<UserIntentWidgetProps> = ({
  engine,
  node,
}) => {
  const intent = useSelector((state: RootState) => selectIntentById(state, node.data.intentId));
  return (
    <>
      <BaseWidget node={node} engine={engine} backgroundColor='#09B2F6'>{intent?.expressions[0]?.text}</BaseWidget>
    </>
  );
};

export default UserIntentWidget;